import React from 'react';
import { IconBase } from '../Base';
export const IconChevronUp = (props) => {
    return (React.createElement(IconBase, { ...props },
        React.createElement("path", { d: "M13.3333 11.6667L10 8.33337L6.66667 11.6667", fill: "none", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round", style: { stroke: 'var(--icon-color)' } })));
};
//# sourceMappingURL=Up.js.map